module.exports = __webpack_public_path__ + "static/Landing_Illustration-03.5af7e37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing_Illustration-03.png
// module id = 31
// module chunks = 35783957827783 40787343088564 110745335445244